import { getTaskFrameInfo } from '@/component/Task';
import type { TASK_CONST } from '@/constant';
import type { Task, TaskAllocation, User } from '@/type';

import { createTaskAllocations } from '../util';

export const useDefaultRedistributionValue = (task: Task) => {
  const frameInfo = getTaskFrameInfo(task);

  const makeDefaultValue = (): {
    taskAllocations: TaskAllocation[];
    unAssignedUserID: User['id'][];
  } => {
    const { userMoreOrEqualThanFrame, fullFrameCount } = frameInfo;

    const defaultUnAssignedUserID = userMoreOrEqualThanFrame
      ? (task.userTask
          ?.filter((_, idx) => idx >= fullFrameCount)
          .map(ut => ut.userID) ?? [])
      : [];

    const defaultTaskAllocations = createTaskAllocations({
      task,
      frameInfo,
      unAssignedUserID: defaultUnAssignedUserID,
    });

    return {
      taskAllocations: defaultTaskAllocations,
      unAssignedUserID: defaultUnAssignedUserID,
    };
  };

  return { makeDefaultValue };
};

export const useDefaultReallocateRatioValue = (task: Task) => {
  const makeDefaultValue = (): {
    distributions: TaskAllocation<TASK_CONST.TASK_DISTRIBUTE_METHOD.RATIO>[];
    totalTaskRatio: number;
  } => {
    const totalUserTaskLength = task.userTask?.length ?? 0;
    const totalTaskRatio = 100;
    let temp = totalTaskRatio;

    const distributions =
      task.userTask?.map((userTask, index) => {
        let allocateRatio = Math.round(totalTaskRatio / totalUserTaskLength);

        if (index === totalUserTaskLength - 1) {
          allocateRatio = temp;
        }

        temp -= allocateRatio;

        return {
          userID: userTask.userID,
          allocateRatio,
        };
      }) ?? [];

    return {
      distributions,
      totalTaskRatio,
    };
  };

  return { makeDefaultValue };
};
